import styled from '@xstyled/styled-components'

export const NavWrapper = styled.nav`
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  padding: 1rem;
`
